(function () {
  const carousels = document.querySelectorAll('[data-customer-reviews]');
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('.customer-reviews__track');
    const prev = carousel.querySelector('[data-action="prev"]');
    const next = carousel.querySelector('[data-action="next"]');
    if (!track) return;

    const getStep = () => {
      const card = track.querySelector('.customer-reviews__card');
      return card ? card.offsetWidth : track.clientWidth;
    };

    const setDisabled = (button, isDisabled) => {
      if (!button) return;
      button.classList.toggle('customer-reviews__arrow--disabled', isDisabled);
      button.disabled = isDisabled;
      button.setAttribute('aria-disabled', String(isDisabled));
    };

    const updateArrows = () => {
      const tolerance = 2;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= tolerance;
      const atEnd = track.scrollLeft >= maxScroll - tolerance;

      setDisabled(prev, atStart);
      setDisabled(next, atEnd || maxScroll <= 0);
    };

    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    let scheduled = false;
    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateArrows();
      });
    };

    track.addEventListener('scroll', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(scheduleUpdate);
      ro.observe(track);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    updateArrows();
  });
})();
